import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full max-w-screen flex-col gap-3',
    item: 'flex w-full items-baseline justify-between last:max-md:mb-5',
    label:
      'flex grow items-baseline whitespace-nowrap after:mx-3 after:block after:h-[4px] after:w-full after:bg-[linear-gradient(90deg,#747d81_0%,#747d81_33.33%,transparent_33.33%,transparent_100%)] after:[background-size:6px_1px] after:bg-bottom after:bg-repeat-x',
    value: 'max-w-[60%]'
  }
});
